export default "__VITE_ASSET__09842abc__"